let clerkInstance = null;

export function setClerkInstance(instance) {
  clerkInstance = instance;
}

export async function getClerkSessionToken() {
  return clerkInstance?.session?.getToken() || null;
}
